import { render, staticRenderFns } from "./HomeUser.vue?vue&type=template&id=4b20e2e2&scoped=true&"
import script from "./HomeUser.vue?vue&type=script&lang=js&"
export * from "./HomeUser.vue?vue&type=script&lang=js&"
import style0 from "./HomeUser.vue?vue&type=style&index=0&id=4b20e2e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20e2e2",
  null
  
)

export default component.exports